import { React, retry, isSSR } from '@common'
import loadable from '@loadable/component'

import type { LeaderLineProps, HiddenOptions } from './leader-line'

export type { LeaderLineProps, HiddenOptions }

const LeaderLineAsync = loadable<LeaderLineProps>(
    () => retry(() => import('./leader-line')),
    { ssr: false }
)

export const LeaderLine:FC<LeaderLineProps> = (props) => {
    if (isSSR) return null

    return <LeaderLineAsync {...props} />
}
